import useRoutes from '../../hooks/useRoutes';

export const getFormReferenceMatchPath = (
  matchPath: string,
  routes: ReturnType<typeof useRoutes>
) => {
  if (matchPath === routes.relative.formAddAction()) {
    return routes.relative.formAddActionReference();
  }
  if (matchPath === routes.relative.formListAddAction()) {
    return routes.relative.formListAddActionReference();
  }
  if (matchPath === routes.relative.formListCopyAction()) {
    return routes.relative.formListCopyActionReference();
  }
  if (matchPath === routes.relative.formListEditAction()) {
    return routes.relative.formListEditActionReference();
  }
  if (matchPath === routes.relative.formSubsetAddAction()) {
    return routes.relative.formSubsetAddActionReference();
  }
  if (matchPath === routes.relative.formSubsetCopyAction()) {
    return routes.relative.formSubsetCopyActionReference();
  }
  if (matchPath === routes.relative.formSubsetEditAction()) {
    return routes.relative.formSubsetEditActionReference();
  }

  //fallback
  return '/:rest(.+)/reference/:referenceDatasetId/:field';
};
